export default {
  // ljy语言配置
  Reset_default_style: "恢复默认风格",
  Modify_style: "修改风格",
  Add_new_style: "新增风格",
  You_must_save_it_again_for_the_changes_to_take_effect:
    "对风格进行修改后，须重新保存，才可生效；",
  Click_to_add_a_new_style_After_entering_the_style_name_and_pressing_Enter_or_clicking_outside_the_input_box_the_style_can_be_saved:
    "点击可新增风格，输入风格名称后回车或点击输入框外区域即可保存；",
  Click_to_use_the_initial_default_style: "点击可使用初始默认风格；",
  Drag_and_drop_fields_to_sort: "可拖拽字段进行排序；",
  Each_SKU_storage_fee_calculation_starts_from_the_batch_entry_date:
    "每个SKU入库批次开始计算仓租天数",
  Dispatch_return_items: "下发退件",
  Only_save_the_hour_minute_and_second_of_the_confirmation_time:
    "仅保存确认时间的时分秒",
  When_conducting_a_quick_search: "快捷查询时",
  the_default_end_date_is_set_to_today_date: "默认结束日期为今日日期",
  Query_the_start_date_based_on_the_saved_time_period_in_real_time:
    "根据保存的时间段实时查询开始日期",
  Today_delivery: "今日达",
  Nextday_delivery: "次日达",
  Today_delivery_Platform: "平台今日达",
  Today_delivery_Shopee: "Shopee今日达",
  Nextday_delivery_Shopee: "Shopee次日达",
  Today_delivery_Lazada: "Lazada今日达",
  Nextday_delivery_Lazada: "Lazada次日达",
  Today_delivery_Tiktok: "Tiktok今日达",
  Nextday_delivery_Tiktok: "Tiktok次日达",
  Today_delivery_Temu: "Temu今日达",
  Nextday_delivery_Temu: "Temu次日达",
  You_cannot_choose_both_today_and_next_day_delivery:
    "不能同时选择今日达与次日达",
  Failed_to_load_custom_fields: "加载自定义查询字段失败",
  Has_Invoice: "有无发票",
  The_file_naming_format_is_incorrect_the_last_item_must_be_the_invoice_serial_number_id_a_pure_number:
    "文件命名格式不正确，最后一项必须是发票流水号id（纯数字）",
  manageAddTransferOutTask: "创建移仓迁出任务",
  manageEditTransferOutTask: "编辑移仓迁出任务",
  No_available_goods: "暂无可用商品",
  One_click_transfer_out_goods: "一键迁出商品",
  Select_Inventory_Product: "选择库存商品",
  Pickup_at_location: "上门",
  Delivery_service: "快递",
  Truk_delivery: "卡派",
  transfer_out_type: "迁出类型",
  shipped_method: "发运方式",
  Failed_to_retrieve_current_logged_in_customer_information:
    "获取当前登录客户信息失败",
  ATrigger_an_alert_when_the_current_time_minus_the_task_start_time_exceeds_the_warning_threshold_notify_the_corresponding_account_of_the_role_in_their_to_do_list:
    "当前时间-任务开始时间＞预警值时触发预警；通知到角色对应账号的待办中",
  Trigger_an_alert_when_the_inventory_quantity_at_a_storage_location_is_below_the_warning_threshold_and_there_is_stock_available_in_backup_or_temporary_locations:
    "库位库存数量＜预警值，且在备货或临时库位有货的情况下触发预警；",
  The_notification_will_be_sent_to_the_corresponding_role_s_account_as_a_pending_task:
    "通知到角色对应账号的待办中",
  Return_Order_Daily_Logistics_Page: "每日物流退件收货报表",
  Return_Order_Daily_Logistics_Customer_Page: "每日客户物流退件收货报表",
  Return_Order_Daily_Logistics_Product_Page: "每日客户退货商品收货报表",
  Return_Order_Monthly_Logistics_Product_Page: "每月客户退货商品收货报表",
  Please_select_the_customer_company: "请选择客户公司",
  isolated_storage_location_up: "隔离库位上架",
  notificationAccount: "通知账号配置",
  Add_notification_account: "添加通知账号",
  Staff_account: "通知人",
  Staff_status: "启用状态",
  Please_select_currency_type: "请选择币种",
  Please_Select_WMS_status: "请选择WMS状态",
  When_using_corporate_online_banking_for_payment: "使用企业网银支付时",
  a_handling_fee_of_10_RMB_per_transaction_will_be_charged_if_the_single_recharge_amount_is_less_than_5000_RMB:
    "单笔充值金额小于5000 RMB时，收取10 RMB/笔手续费",
  deducted_from_the_recharge_amount: "在充值金额中扣除",
  otherwise_no_fee_will_be_charged: "其余情况免费",
  Operational_video: "操作视频",
  Please_upload_mp4_format_video_file_and_not_more_than_300_MB:
    "请上传.mp4格式的视频，文件大小不超过300MB",
  Upload: "上传",
  Reschedule_delivery: "重新预约发货",
  Only_Shopee_today_delivery_orders_can_be_rescheduled_for_shipment:
    "仅支持Shopee今日达的订单重新预约发货",
  Order_does_not_meet_the_conditions_for_rescheduling: "订单不满足重新预约条件",
};
